import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { VacancyData } from 'features/TabbedJobView/VacanciesTab/types';

export interface UseCreateEditVacanciesMutationVariables {
  data: VacancyData;
}

export function useCreateEditVacanciesMutation(
  roleId: number,
  options?: Omit<
    UseMutationOptions<void, AxiosError, UseCreateEditVacanciesMutationVariables, unknown>,
    'mutationFn'
  >
): UseMutationResult<void, AxiosError, UseCreateEditVacanciesMutationVariables, unknown> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data }) => {
      return axios.put(`/api/roles/${roleId}/vacancies/`, data).then((res) => res.data);
    },
    ...options,
    onSuccess: (data, variables, context) => {
      const queryKey = ['tabbedJobViewVacanciesByJobId', roleId];

      queryClient.invalidateQueries({
        queryKey,
        exact: true,
      });

      options?.onSuccess?.(data, variables, context);
    },
  });
}
